// Libraries.
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
// Slices.
import { openModal } from "./contactModal/modalSlice";
// Components.
import Button from "../components/Button";
// Icons.
import LogoIcon from "../assets/icons/gear-icon.svg";
// Styles.
import { HeaderContainer } from "../styles/features/HeaderNavbarStyles";

interface HeaderNavbarProps {
  scrolled: boolean;
}

export const HeaderNavbar: React.FC<HeaderNavbarProps> = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(openModal());
  };

  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <HeaderContainer className="header" scrolled={scrolled}>
      <div className="logo">
        <img src={LogoIcon} alt="GearFuGearWeb Solutions" />
        <p>GearWeb</p>
        <p>Solutions</p>
      </div>
      <nav>
        <li>
          <Button className="contact-button" onClick={handleClick}>
            Contáctanos
          </Button>
        </li>
      </nav>
    </HeaderContainer>
  );
};
